import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

/**
 * Flag to enable/disable logistic charges messages
 */
@Injectable()
export class LogisticChargesFeature implements IFlagFeature {
  name = Features.LOGISTIC_CHARGES;

  public isEnabled(container?: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
